import { useCallback, useState } from "react";
import { BaseProps } from "../generic/BaseProps";

export interface EditableTitleProps {
  title: string;
  onUpdate: (title: string) => Promise<void>;
}

export function EditableTitle({
  onUpdate,
  title,
}: BaseProps & EditableTitleProps): JSX.Element {
  const [editingTitle, setEditingTitle] = useState<string | null>(null);

  const activateEditMode = () => {
    if (editingTitle === null) {
      setEditingTitle(title);
    }
  };

  const handleCancel = useCallback(
    (evt?: any) => {
      evt?.stopPropagation();
      setEditingTitle(null);
    },
    [setEditingTitle],
  );

  const handleInputKey = useCallback(
    async (event) => {
      if (event.key === "Enter") {
        if (!editingTitle) {
          //cancel, title cant be empty, maybe show error in future, or animate input shaking or something along those lines?
          return;
        }

        await onUpdate(editingTitle);
        setEditingTitle(null);
      }
      if (event.key === "Escape") {
        handleCancel();
        event.stopPropagation();
        event.preventDefault();
      }
    },
    [editingTitle, handleCancel, onUpdate],
  );

  function handleChangeValue(event: React.FormEvent<HTMLInputElement>) {
    setEditingTitle(event.currentTarget.value);
  }

  return (
    <span
      onClick={activateEditMode}
      className="cursor-text"
      tw="inline-block bg-white relative break-words"
    >
      {editingTitle !== null && (
        <span tw="inline-grid grid-cols-1 break-words">
          <input
            value={editingTitle}
            tw="tag-val"
            placeholder="value..."
            onKeyUp={handleInputKey}
            onChange={handleChangeValue}
            onBlur={handleCancel}
            autoFocus
          />
        </span>
      )}
      {editingTitle == null && title}
    </span>
  );
}
